import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import { getAnnotationColor } from "../../annotationColors";

const LigandDistanceByAnnotation = ({ ligandData }) => {
  const [plotData, setPlotData] = useState([]);
  const [layout, setLayout] = useState({});

  useEffect(() => {

    if (!Array.isArray(ligandData) || ligandData.length === 0) {
      setPlotData([]);
      return;
    }

    // Bucket distances by annotation type
    const buckets = {};

    ligandData.forEach((row) => {
      const annotation = (row?.annotation || "unknown").trim();
      const d = parseFloat(row?.distance);
      if (isNaN(d)) return;

      if (!buckets[annotation]) buckets[annotation] = [];
      buckets[annotation].push(d);
    });

    // Order categories by median distance ascending — tightest binding first
    const median = (arr) => {
      const sorted = [...arr].sort((a, b) => a - b);
      const m = Math.floor(sorted.length / 2);
      return sorted.length % 2 ? sorted[m] : (sorted[m - 1] + sorted[m]) / 2;
    };

    const orderedAnnotations = Object.keys(buckets)
      .sort((a, b) => median(buckets[a]) - median(buckets[b]));

    const traces = orderedAnnotations.map((annotation) => {
      const color = getAnnotationColor(annotation);
      return {
        y: buckets[annotation],
        name: annotation,
        type: "box",
        boxpoints: "outliers",
        marker: { color },
        line:   { color: "#333", width: 1 },
        fillcolor: color,
        hovertemplate: `${annotation}<br>Distance: %{y:.2f} Å<extra></extra>`,
      };
    });

    setPlotData(traces);

    setLayout({
      autosize: true,
       font: { size: 9 },
      title: { text: "Contact Distance by Ligand Type" },
      xaxis: {
        type: "category",
        title: { text: "Ligand annotation" },
      },
      yaxis: {
        title: { text: "Distance (Å)" },
        zeroline: false,
      },
      showlegend: true,
      legend: {
        title: { text: "Annotation" },
        orientation: "v",
        x: 1.02,
        y: 1,
      },
      margin: { t: 50, b: 80, l: 60, r: 80 },
    });
  }, [ligandData]);

  return (
    <div className="aspect-square card">
      <Plot
        data={plotData}
        layout={layout}
        useResizeHandler
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default LigandDistanceByAnnotation;
